// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports

import Box from "@mui/material/Box";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import {contractUpdate} from "../../../Contract/ContractClient";
import {changeWorkQueue} from "../../workQueueSlice";
import PanToolIcon from "@mui/icons-material/PanTool";


// main function
export default function HoldContract({ onMenuClose, rowContractData, selectorContractList }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************

    const currentUserName = localStorage.getItem('userName');
    const contractArray = useSelector((state) => state.workQueueSlc.value.mousedContractContractIdArray);


    const handleHold = () => {
        onMenuClose();
        contractUpdate(contractArray, [], [],'Update Status',
            '3247', null, currentUserName, true)
            .then(() => {
                dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
            });
    };


    return (

        <Box>
            {(rowContractData.contractLevel === "Series" ||
                    rowContractData.contractLevel === "Season" ||
                    rowContractData.contractLevel === "Residuals" ||
                    rowContractData.contractLevel === "Royalties" ||
                    rowContractData.contractLevel === "Property" ||
                    rowContractData.contractLevel === "Labor Group" ||
                    (rowContractData.contractLevel === "Guild" && rowContractData.contractStatus !== "On Hold")) &&
                <MenuItem onClick={handleHold}>
                    <ListItemIcon>
                        <PanToolIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Hold</ListItemText>
                </MenuItem>}
        </Box>

    )

}
